import * as React from 'react';
import {styled} from '@packages/utilities/styled';
import {boxStyles} from './BoxStyles';
import {type BoxProps} from './Box.types';

const View = styled('div')(boxStyles);

/**
 * # Box
 *
 * Box is a low-level layout component that comes pre-configured Design System settings, which including flexbox rendering, layout rendering, and the spacing system.
 *
 * **Box is intended to be a solution for very minor UI adjustments. It is not a replacement for the styling library.**
 *
 * ## Usage
 *
 * Below is a basic (rough) example of `Box` being used to micro-nudge a `Text` within a `Grid`.
 *
 * ```jsx
 * import React from 'react';
 * import {Box} from '@packages/systems/design-system/Box';
 * import {Grid} from '@packages/systems/design-system/Grid';
 * import {Text} from '@packages/systems/design-system/Text';
 *
 * function Example() {
 *   return (
 *     <Grid gridTemplateColumns="1fr 1fr">
 *       <Text>Example</Text>
 *       <Box marginLeft={-1}>
 *         <Text>...</Text>
 *       </Box>
 *     </Grid>
 *   );
 * }
 * ```
 */
export const Box = React.forwardRef<any, BoxProps>((props, ref) => {
  return <View data-legacy-ds="Box" {...props} ref={ref} />;
});

export default Box;
